import * as React from 'react'

/**
 * Subscribes the component to a clock tick: re-renders once per interval and
 * returns the current time bucketed to that interval. Lets relative-time
 * labels ("3 seconds ago") roll forward without any other re-render.
 */
export function useNow(intervalMs = 1000) {
  return React.useSyncExternalStore(
    (onChange) => {
      const id = setInterval(onChange, intervalMs)
      return () => clearInterval(id)
    },
    // Bucket by interval so the snapshot is stable within a tick.
    () => Math.floor(Date.now() / intervalMs)
  )
}
